import {createContext} from 'react';

export type CreateNewEventContextType = {
	activeStep: number;
	onCloseModal?: () => void;
	handleBackStep: () => void;
	handleNextStep: () => void;
};

export const CreateNewEventContext = createContext({} as CreateNewEventContextType);
